import LoadingPage from '@/components/LoadingPage/LoadingPage';
import { useLinkUserAccount } from '@/modules/auth/hook/use-link-user-account';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { toast } from 'react-toastify';
import DashboardOrganizationRedirector from './DashboardRedirector';

export default function DashboardAuthCallback() {
  const { t } = useTranslation();
  const auth = useAuth();

  const { isLoading, isError } = useLinkUserAccount({
    disabled: auth.isLoading || !auth.isAuthenticated,
  });

  useEffect(() => {
    if (!isLoading && isError) {
      toast.error(t('error.unable_to_link_user_account'));
    }
  }, [auth, isError, isLoading, t]);

  if (auth.isLoading || isLoading) {
    return <LoadingPage />;
  }

  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return <LoadingPage />;
  }

  return <DashboardOrganizationRedirector />;
}
